<template>
  <div class="page">
    <!-- 顶部标签 start -->
    <div class="uploadTabs">
      <a href="javascript:;" class="tab" :class="{act:cur==0}" @click="cur=0;onloadRequest()">全部<span class="line" /></a>
      <a href="javascript:;" class="tab" :class="{act:cur==1}" @click="cur=1;onloadRequest()">已发布<span class="line" /></a>
      <a href="javascript:;" class="tab" :class="{act:cur==2}" @click="cur=2;onloadRequest()">审核中<span class="line" /></a>
      <a href="javascript:;" class="tab" :class="{act:cur==3}" @click="cur=3;onloadRequest()">未通过</a>
    </div>
    <!-- 顶部标签 end -->

    <!-- panels start -->
    <div class="uploadPanels">
      <!-- 全部  -->
      <div v-for="(s,idx) in list" :key="idx" class="panel digColl uploadColl" :data-index="idx">
        <div class="digList">
          <div class="itm">
            <h4 class="t" :data-index="idx" @click="toDetail">{{ s.collectionName }}</h4>
            <p class="desc" :data-index="idx" @click="toDetail">{{ s.description }}</p>
            <div class="entLabel">
              <span v-if="s.status==8 && s.releaseStatus == 1" class="span_state state-grey">已发布</span>
              <span v-if="s.status==5 && s.auditTagStatus == 0" class="span_state state-yellow">审核中</span>
              <span v-if="s.status==8 && s.releaseStatus == 0" class="span_state state-yellow">审核中</span>
              <span v-if="s.status==6 && s.publisherStatus == 0" class="span_state state-yellow">审核中</span>
              <span v-if="s.status==5 && s.auditTagStatus == 2 && s.isDeleted == 1" class="span_state state-red">未通过</span>

              <div v-if="s.pictureNumber >'0' || s.audioNumber>'0' || s.videoNumber">
                <span><em v-if="s.pictureNumber >'0'">{{ s.pictureNumber }}图片</em><em v-if="s.videoNumber>'0'">&nbsp;&nbsp;{{ s.videoNumber }}视频</em><em v-if="s.audioNumber>'0'">&nbsp;&nbsp;{{ s.audioNumber }}音频</em><em v-if="s.otherNumber > 0">&nbsp;&nbsp;{{ s.otherNumber }}文件</em></span>
              </div>
              <a v-if="s.status==8 && s.releaseStatus == 1 && s.applyRemoveStatus == 0" href="javascript:;" class="btn-del" :data-index="idx" @click.stop="showdelapply">删除</a>
            </div>
            <!-- <div @click="toDetail(s.id)" class="img" :style="{background:'url(' + s.preview +')','background-position':'center','background-size':'cover'}"></div> -->
            <div :data-index="idx" class="img" style=" background:#999" @click="toDetail">
              <img :src="s.preview" alt="" style="width:100%; height:100%; border-radius:4px">
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMore" style="height: 50px; width: 100%; color: #333; line-height: 50px; font-size: 12px;text-align: center;" @click="loadMore">
        点击加载更多
      </div>
      <div v-else style="height: 50px; width: 100%; color: #333; line-height: 50px; font-size: 12px;text-align: center;">
        没有更多了
      </div>
    </div>
    <!-- panels end -->

    <!-- 导航 start -->
    <div class="naviPosition" />
    <div class="digNavigate">
      <router-link class="navItm" :to="{ name: 'Waphome' }">
        <img src="../../../../images/home.png" class="img-normal">
        <img src="../../../../images/home_select.png" class="img-active">
        <label>首页</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Waplist' }">
        <img src="../../../../images/res.png" class="img-normal">
        <img src="../../../../images/res_select.png" class="img-active">
        <label>特藏</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapupload' }">
        <img src="../../../../images/upload.jpg" class="img-normal">
        <img src="../../../../images/upload_select.jpg" class="img-active">
        <label>上传</label>
      </router-link>
      <router-link class="navItm active" :to="{ name: 'Wapuser' }">
        <img src="../../../../images/use.png" class="img-normal">
        <img src="../../../../images/use_select.png" class="img-active">
        <label>我的</label>
      </router-link>
    </div>
    <!-- 导航 end -->
    <applyRemoveWap ref="delapply" :datas="applyDelReason" @apply="requestDelsource" />
  </div>
</template>

<script>
import api from '../../../../api/userpage.js'
import applyRemoveWap from '@/components/applyremoveWap/index.vue'
// import auth from '../../../../models/auth.js'
import apply from '../../../../api/common.js'

export default {
  name: 'Wapuserupload',
  components: {
    applyRemoveWap
  },
  data() {
    return {
      cur: '0',
      list: [],
      totalPage: 1,
      reqdel: {
        length: 0,
        desc: '',
        index: -1
      },
      current: 1,
      mouseOverIndex: -1,
      showDelDialog: false,
      applyDelReason: [],
      chooseType: 1,
      applyRemoveWap
    }
  },
  // watch: {
  //   status() {
  //     this.request()
  //   }
  // },
  computed: {
    isMore() {
      return this.current < this.totalPage
    }
  },
  created() {
    this.onloadRequest()
  },
  methods: {
    onloadRequest() {
      this.current = 1
      this.request()
    },
    loadMore() {
      this.current = this.current + 1
      this.request()
    },
    request() {
      var params = {}
      const paramsSize = { current: this.current, size: 10 }
      if (parseInt(this.cur) === 0) {
        params = {
          chooseType: 1
        }
      } else if (parseInt(this.cur) === 1) {
        params = {
          chooseType: 3
        }
      } else if (parseInt(this.cur) === 2) {
        params = {
          chooseType: 2
        }
      } else if (parseInt(this.cur) === 3) {
        params = {
          chooseType: 4
        }
      }
      params = Object.assign(paramsSize, params)
      const that = this
      api.personsources(params).then(r => {
        // that.list = r.data.records
        that.totalPage = r.data.pages
        if (this.current === 1) {
          that.list = r.data.records
        } else {
          that.list = that.list.concat(r.data.records)
        }
      }).catch(() => {
        that.list = []
      })

      apply.listmenu({ code: 'delete_type' }).then(r => {
        that.applyDelReason = r.data[0].children
      })
    },
    requestDelsource(e) { // 删除资源请求
      console.log(this.list[this.reqdel.index])
      const params = {
        collectionId: this.list[this.reqdel.index].collectionId,
        removeTypeCode: 1,
        removeContent: e.desc
      }
      const that = this
      api.removesource(params).then(r => {
        that.list[that.reqdel.index].applyRemoveStatus = 1
        console.log('删除成功', r)
        // this.onloadRequest()
        that.$message({
          showClose: false,
          message: '删除申请已提交',
          type: 'success'
        })
      }).catch(err => {
        console.log(err)
      })
    },
    showdelapply(e) { // 删除资源事件
      this.$refs.delapply.show()
      this.reqdel.index = e.currentTarget.dataset.index
    },
    toDetail(v) {
      const index = v.currentTarget.dataset.index
      const value = this.list[index]
      if (value.status === 8 && value.releaseStatus === 1) {
        this.$router.push({
          name: 'Wapdetail',
          query: {
            rsId: value.id,
            permission: value.permissionRange,
            me: 1
          }
        })
      }
    },
    dismiss() {
      this.requestDelsource()
    }
  }
}
</script>
<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style scoped>
.page{ padding-top:1.15rem !important}
</style>
